import ApiService from "@/core/services/ApiService";
import JwtService from "@/core/services/JwtService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";
import { errManager } from "@/core/config/Tools";

export interface User {
  lastname: string;
  surname: string;
  email: string;
  password: string;
  person: unknown,
  api_token: string;
  api_company: string;
}

export interface UserAuthInfo {
  errors: unknown;
  user: User;
  isAuthenticated: boolean;
}

@Module
export default class AuthModule extends VuexModule implements UserAuthInfo {
  errors = {};
  user = {} as User;
  isAuthenticated = !!JwtService.getToken();

  /**
   * Get current user object
   * @returns User
   */
  get currentUser(): User {
    return this.user;
  }

  /**
   * Verify user authentication
   * @returns boolean
   */
  get isUserAuthenticated(): boolean {
    return this.isAuthenticated;
  }

  /**
   * Get authentification errors
   * @returns array
   */
  get getErrors() {
    return this.errors;
  }

  @Mutation
  [Mutations.SET_ERROR](error) {
    this.errors = { ...error };
  }

  @Mutation
  [Mutations.SET_AUTH](user) {
    this.isAuthenticated = true;
    this.user = user;
    this.errors = {};
    JwtService.saveToken(user.api_token);
    JwtService.saveCompany(user.api_company)
  }

  @Mutation
  [Mutations.SET_USER](user) {
    this.user = user;
  }

  @Mutation
  [Mutations.SET_PASSWORD](password) {
    this.user.password = password;
  }

  @Mutation
  [Mutations.PURGE_AUTH]() {
    this.isAuthenticated = false;
    this.user = {} as User;
    this.errors = [];
    JwtService.destroyToken();
  }

  @Action
  [Actions.LOGIN](data) {
    this.context.commit(Mutations.SET_AUTH, data);
  }

  @Action
  [Actions.LOGOUT]() {
    this.context.commit(Mutations.PURGE_AUTH);
  }

  @Action
  [Actions.REGISTER](credentials) {
    return ApiService.post("register", credentials)
      .then(({ data }) => {
        this.context.commit(Mutations.SET_AUTH, data);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, response.data.errors);
      });
  }

  @Action
  [Actions.FORGOT_PASSWORD](payload) {
    return ApiService.post("forgot_password", payload)
      .then(() => {
        this.context.commit(Mutations.SET_ERROR, {});
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, response.data.errors);
      });
  }

  @Action
  async [Actions.VERIFY_ACCESS](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.post("api/user/verify-access", payload)
      .then(({ data }) => {
        return true
        //this.context.commit(Mutations.SET_AUTH, data);
      })
      .catch(({ response }) => {
        //this.context.commit(Mutations.PURGE_AUTH);
        errManager(response);
        //this.context.commit(Mutations.SET_ERROR, response.data.messages);
      });
    }else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  @Action
  async [Actions.VERIFY_AUTH](payload) {
    if (JwtService.getToken()) {
      let cntx = this.context;
      return await new Promise(function (resolve, reject) {
        ApiService.setHeader();
        
        ApiService.post("api/user/setting", payload)
          .then(({ data }) => {
            cntx.commit(Mutations.SET_AUTH, data);
            //resolve(data)
          })
          .catch(({ response }) => {
            cntx.commit(Mutations.SET_ERROR, response.data.errors);
            cntx.commit(Mutations.PURGE_AUTH);
            //reject(response);
            errManager(response);
          });
      })

    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }
}
